import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-ohel-camp-pagamento-completato',
  standalone: true,
  templateUrl: './pagamento-completato.component.html',
  styleUrl: './pagamento-completato.component.scss',
  imports: [CommonModule, RouterLink],
})
export class OhelCampPagamentoCompletatoComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private meta = inject(Meta);
  private title = inject(Title);

  sessionId: string | null = null;

  ngOnInit() {
    this.title.setTitle('Pagamento Completato - Ohel Camp 2026');

    this.meta.updateTag({
      name: 'robots',
      content: 'noindex, nofollow',
    });

    this.sessionId = this.route.snapshot.queryParamMap.get('session_id');
  }
}
